import { Button } from "react-bootstrap"
import { AssessmentSubmissionResponse } from "shared/types/moduleTypes"
import { formatGrade } from "shared/helpers/formatGrade"
import { StudentSubmissionStatusType } from "shared/types/studentTypes"

interface Props {
    assessmentSubmission: AssessmentSubmissionResponse
    updateSubmissionStatus: (status: StudentSubmissionStatusType) => void
}

const TeacherAssessmentSidebar = ({ assessmentSubmission, updateSubmissionStatus } : Props) => {
  if (assessmentSubmission === null) return <></>
    return <>
        <div className="d-grid gap-2">
            <div className="border-bottom border-secondary">
                {assessmentSubmission.status === "graded" && <p className="text-success fw-bold fs-4"><i className={`fas fa-check`}/> Graded</p>}
                {assessmentSubmission.status === "rework-required" && <p className="text-info-emphasis fw-bold fs-5"><i className={`fas fa-repeat`}/> Resubmission Requested</p>}
                {assessmentSubmission.status === "rejected" && <p className="text-danger fw-bold fs-4"><i className={`fas fa-times`}/> Rejected</p>}
            </div>

            <strong>Assessment Grade: </strong>{formatGrade((assessmentSubmission.grade ?? 0).toString())}

            <Button variant="primary" onClick={() => updateSubmissionStatus("graded")}>Grade Submission</Button>
            <Button variant="danger" onClick={() => updateSubmissionStatus("rejected")}>Reject Submission</Button>
            <Button variant="info" onClick={() => updateSubmissionStatus("rework-required")}>Request Rework</Button>
        </div>
    </>
}

export default TeacherAssessmentSidebar
